import { render, staticRenderFns } from "./ReflectRecordTable.vue?vue&type=template&id=50e67b86&scoped=true&"
import script from "./ReflectRecordTable.vue?vue&type=script&lang=js&"
export * from "./ReflectRecordTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e67b86",
  null
  
)

export default component.exports